<template>
  <div id="showScroll" class="container-ticket">
    <div class="receipt  container-ticket" v-bind:style="dataToTicket.ancho">
      <h1 class="main-title"></h1>
      <div class="address" style="font-size: 14px" v-if="dataToTicket.tenantTicket == 'PCUN'">CLUBS PUERTO CANCUN SA DE CV</div>
      <div class="address" style="font-size: 14px; margin-top:-10px;" v-if="dataToTicket.tenantTicket == 'PCUN'">Regimen general de personas morales</div>
      <div class="address" style="font-size: 16px">{{ dataToTicket.TitleTicket}}</div>
      <div class="address" style="font-size: 14px; margin-top:-10px;" v-if="dataToTicket.tenantTicket == 'PCUN'">CPC210813VDA</div>

      
      <div v-html="dataToTicket.DirTicket" class="address">
      </div>
      <div class="detailTicket" v-if="dataToTicket.tenantTicket == 'PCUN'">Cancun Quintana Roo</div>
      <div class="detailTicket">Ticket {{ dataToTicket.Folio }}</div>
      <div  class="detailTicket">
        Cajero: {{ dataToTicket.Cajero ? dataToTicket.Cajero.nm : "" }}
      </div>
      <div class="detailTicket">
        Fecha:
        {{$pgsHelper
            .getDate(dataToTicket.Turno.fe)
            .format("DD-MM-YYYY")}} 
    
      </div>
      <div class="centerItem bold">
        <div class="item">
          Cliente:
          {{
            dataToTicket.Cliente
              ? dataToTicket.Cliente.Nombre
              : "Cliente en general"
          }}
        </div>
      </div>

      <div class="survey bold">
        <p>Venta</p>
      </div>
      <div style="margin-bottom:10px;" id="tablaDetalle">
        <table style="width: 100%">
          <template v-for="(item, index) in dataToTicket.Catalogo">
            <tr
              :key="index + 10000"
              v-bind:class="{ selectedRow: item.selected }"
            >
              <td width="10%" v-if="(item.Cnt - (item.Dto ? item.Dto : 0)) > 0">{{ item.Cnt - (item.Dto ? item.Dto : 0) }}</td>
              <td width="10%" v-if="(item.Cnt - (item.Dto ? item.Dto : 0)) == 0">{{ item.Cnt }}</td>

              <td width="80%">
                <p v-if="item.Tip == 'RVA-Reserva'">
                  {{ item.Nombre }}|{{ item.Catalogo[0].Nombre }}
                </p>
                <p v-else-if="item.Tip == 'RVA-Addon'">
                  {{ item.Nombre }}
                  {{ item.NombreRider ? " | " + item.NombreRider : "" }}
                </p>
                <p v-else-if="item.Tip == 'Cupon' || item.Tip == 'Cuenta'">
                  {{ item.Nombre }}

                <template v-if="item.Tip == 'Cuenta'">
                  <template v-for="(cupItem,indexcatCuenta) in item.Catalogo">
                    <li :key="indexcatCuenta">
                      {{ cupItem.Cnt }} {{ cupItem.Nombre }} ${{ $pgsHelper.formatNumber(cupItem.tr.C * cupItem.Cnt)}}
                    </li>
                  </template>
                </template>
                </p>
                <p v-else>{{ item.Nombre }}</p>
              </td>
              <td width="10%" v-if="!dataToTicket.sinPrecio && ((item.Cnt - (item.Dto ? item.Dto : 0)) > 0)">${{$pgsHelper.formatNumber( (item.Cnt - (item.Dto ? item.Dto : 0)) * item.pu.C )}} {{ (item.pu.M === 'MXN')?'':item.pu.M }}</td>
              <td width="10%" v-if="!dataToTicket.sinPrecio && ((item.Cnt - (item.Dto ? item.Dto : 0)) == 0)">${{$pgsHelper.formatNumber( (item.Cnt) * item.pu.C )}} {{ (item.pu.M === 'MXN')?'':item.pu.M }}</td>

            </tr>
            <template v-for="(desc, indexDes) in item.Descuentos">
              <tr
                v-if="dataToTicket.DescuentosDesglosados & desc.Activo"
                :key="index + 20000 + indexDes + 'DESC' + item.internalId"
                style="font-size: 15px"
              >
                <td width="10%" class="promoItem">
                  {{ desc.Cnt }}
                </td>
                <td width="80%">{{ desc.Dsc }}</td>
                <td width="20%">
                  ${{ desc.Cur.C }} {{ desc.Cur.M === "MXN" ? "" : desc.Cur.M }}
                </td>
              </tr>
            </template>
           

          </template>
					<template v-for="(desc, indexDescuento) in dataToTicket.totalDescuentos">
            <tr v-if="!dataToTicket.DescuentosDesglosados" :key="indexDescuento + 'DESCUENTO'" style="font-size: 15px">
              <td width="10%" class="promoItem">1</td>
              <td width="80%">{{ desc.Nombre }}</td>
              <td width="20%">${{ desc.Total }}</td>
            </tr>
          </template>
        </table>
      </div>
      <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal">
        <div class="detail">SUBTOTAL</div>
        <div class="detail">${{ dataToTicket.totales ? $pgsHelper.formatNumber((dataToTicket.totales.TotalMxn - dataToTicket.IVA)) : 0 }} {{currenciDefault}}</div>
      </div>
      <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal && dataToTicket.tenantTicket == 'PCUN'">
        <div class="detail">IVA</div>
        <div class="detail">${{ dataToTicket.IVA ? $pgsHelper.formatNumber(dataToTicket.IVA) : 0 }} {{currenciDefault}}</div>
      </div>

      
      <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal">
        <div class="detail">TOTAL</div>
        <div class="detail">${{ dataToTicket.totales? $pgsHelper.formatNumber(dataToTicket.totales.TotalMxn) : 0 }} {{currenciDefault}}</div>
      </div>
      <div class="paymentDetails" v-if="dataToTicket.showDefualtTotal">
        <div style="font-size:12px">{{numToString.num2str(dataToTicket.totales.TotalMxn,((currenciDefault == "MXN")?"Pesos Mexicanos":currenciDefault))}}</div>
      </div>
      
      <div class="paymentDetails bold" v-if="dataToTicket.showDollar">
        <div class="detail">TOTAL USD</div>
        <div class="detail" v-if="!dataToTicket.showRealDollars">${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.TotalUsd) : 0 }} USD</div>
        <div class="detail"  v-if="dataToTicket.showRealDollars">${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.TotalRealUsd) : 0 }} USD</div>
      </div>
      <div class="paymentDetails" v-if="dataToTicket.showDefualtTotal">
        <div class="detail">SU PAGO</div>
        <div class="detail">${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.payPesos) : 0 }} {{currenciDefault}}</div>
      </div>
      <div class="paymentDetails" v-if="dataToTicket.showDollar">
        <div class="detail">SU PAGO USD</div>
        <div class="detail"  v-if="!dataToTicket.showRealDollars">${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.payDollar) : 0 }} USD</div>
        <div class="detail"  v-if="dataToTicket.showRealDollars">${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.payDollarReal) : 0 }} USD</div>
      </div>
      <div class="paymentDetails" v-if="dataToTicket.showDefualtTotal">
        <div class="detail">CAMBIO</div>
        <div class="detail">
          ${{ dataToTicket.Cambio ? $pgsHelper.formatNumber(dataToTicket.Cambio[currenciDefault]) : 0 }} {{currenciDefault}}
        </div>
      </div>
     
        <div style="text-align: center !important; margin-top:2px; margin-botom:25px !important;">
          <b>Metodos de pago</b>
        </div >
        <div >
        <div style="text-align:center !important;">**********************</div>
      </div>
      <div v-if="dataToTicket.showDefualtTotal">
        <template v-for="(pago, index) in dataToTicket.Pagos">
          <div class="pagos" :key="index">
            {{ fixPayName(pago.nm) }} : {{ $pgsHelper.formatNumber(pago.rl.C) }} {{pago.rl.M}}
          </div>
        </template>
        <template v-for="(pago,key) in this.dataToTicket.Props" >
          <div class="paymentDetails"  :key="key">
          <div class="detail">Propina {{pago.nm}} : ${{ $pgsHelper.formatNumber(pago.rl.C) }} {{pago.rl.M}}</div>
          </div>
        </template>
      </div>
      <div
        class="creditDetails"
        style="text-align: center; margin-top: 5px; width: 90%"
      >
        <!--<div class="survey bold">
                            <p>Deslinde de responsabilidad</p>
                            <p class="surveyID"></p>  
                        </div>-->
        Reimpresión<br />
        {{ dataToTicket.TextoTicket }}
      </div>
    </div>
  </div>
</template>



<script>
import "../assets/css/ticket.css";
import { mapGetters } from "vuex";
import Currencies from "../clases/Currencies.js";
import numString from "../clases/numString.js"
export default {
  name: "ticket",
  components: {},
  props: ["dataToTicket","currenciDefault"],
  data() {
    return {
      textTicket: "",
      titleTicket:"",
      DirTicket:"",
      numToString:new numString()
    };
  },
  computed: {
  },
  methods: {
    fixPayName(name){
      if(name == "T"){
        return "Transferencia"
      }else if( name == "D"){
        return "Deposito"
      }
      else if( name == "V"){
        return "Visa"
      }
      else if( name == "M"){
        return "Master Card"
      }
      else if( name == "C"){
        return "Cheques"
      }
      else if( name == "A"){
        return "American Express"
      }else{
        return name
      }
    }
  },
  mounted: function () {
  },
  beforeMount: function () {

  },
};
</script>